<!--
	TEMPLATE
-->
<template>

	<div class="editable-features">
		<div v-if="!isEditView">
			<p v-for="feature in features"><span v-if="features.length !== 0">{{ feature }}</span><span v-if="features.length === 0">none</span></p>
		</div>

		<div v-if="isEditView">
			<edit-features v-model="features" @hasThree="hasErrors = !arguments[0]"></edit-features>
		</div>
	</div>


</template>

<!--
	SCRIPT
-->
<script>
import vModelNested from '@/libs/vModelNested.js';
import EditableFeatures from '../EditableFeatures.vue';

export default {
	props: {
		value: [Array, String],
		isEditView: Boolean
	},
	data: function() {
		return {
			hasErrors: false,
		}
	},
	watch: {
		hasErrors: function() {
			this.$emit('hasErrors', this.hasErrors);
		}
	},
	computed: {
		features: vModelNested
	},
	components: {
		'edit-features': EditableFeatures
	}
}
</script>



// WEBPACK FOOTER //
// src/components/editable-items/EditableFeatures.vue